import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import OrganisationList from "../organisation/OrganisationList";

const Home = () => {
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);

  useEffect(() => {
    // Check if the user is not logged in (e.g., no token)
    if (!token) {
      navigate('/login'); // Redirect to login page
    }
  }, [token, navigate]); // Depend on token and navigate to re-check when they change

  return (
    <div className="text-left">
        <OrganisationList />
    </div>
  );
};

export default Home;